<template>
  <v-app id="inspire">
    <Header type="return"/>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>

          <Menu/>

          <v-container class="col-10">
            <v-row>
              <v-col
                  class="page-top d-flex justify-space-between"
                  cols="12"
              >
                <div>
                  <div class="page-title">{{ buy.buy_name }}</div>
                  <div class="breadcrumb"><span class="breadcrumb-bold">Ресепшен / Рабочий стол / Возврат / Возврат товаров и услуг /</span> {{ buy.buy_name }}</div>
                </div>
              </v-col>
              <v-col>
                <v-sheet class="card rounded-lg" style="padding: 0 !important;">
                  <div class="column" style="padding-top: 20px !important;">
                    <VueDatePicker
                        no-title
                        no-header
                        color="#629f34"
                        v-model="date"
                        style="flex: none !important;"
                    >
                      <template #activator="{ date }">
                        <button
                            class="button custom__button"
                            ref="activator"
                            type="button"
                        >
                          <v-icon
                              dark
                              right
                              small
                              class="mr-2"
                          >
                            mdi-calendar-blank-outline
                          </v-icon>
                          {{ date }}
                        </button>
                      </template>
                    </VueDatePicker>
                  </div>
                  <div class="column mt-5">
                    {{ client.name }}
                  </div>

                  <v-data-table
                      :headers="headersReturn"
                      :items="buy ? buy.buy_list : []"
                      item-key="row_id"
                      v-model="selectReturn"
                      no-data-text="Ничего не найдено"
                      hide-default-footer
                      show-select
                      class="elevation-1 mt-5 custom__table"
                  >
                    <template v-slot:header.data-table-select="{ on, props }">
                      <v-tooltip
                          top
                          content-class="black tooltip-top"
                      >
                        Выбрать все
                        <template v-slot:activator="{ on: onTooltip }">
                          <v-simple-checkbox
                              v-ripple
                              color="#629F33"
                              v-bind="props"
                              v-on="{ ...on, ...onTooltip }"
                          ></v-simple-checkbox>
                        </template>
                      </v-tooltip>
                    </template>
                    <template v-slot:item.data-table-select="{ isSelected, select }">
                      <v-simple-checkbox style="width: 26px !important;" color="#629F33" :value="isSelected" @input="select($event)"></v-simple-checkbox>
                    </template>
                    <template v-slot:item.sum="{item}">
                      {{ item.sum }} ₽
                    </template>
                  </v-data-table>

                  <div class="column mt-5" style="padding-bottom: 20px !important;">
                    <template v-if="selectReturn.length > 0">
                      <v-btn
                          dark
                          class="apply-button"
                          style="background-color: #A13453 !important; color: #FFFFFF!important;"
                          @click="modalReturn"
                      >
                        Применить
                      </v-btn>
                    </template>
                    <template v-else>
                      <v-btn
                          dark
                          class="apply-button"
                      >
                        Применить
                      </v-btn>
                    </template>
                  </div>
                </v-sheet>
              </v-col>
            </v-row>
          </v-container>
        </v-row>
        <v-row justify="center">
          <v-dialog
              v-model="dialogModal"
              persistent
              max-width="540px"
          >
            <v-card>
              <v-card-title class="justify-space-between">
                <div></div>
                <div>
                  <h4>Возврат</h4>
                </div>
                <v-btn icon @click="dialogModal = false" >
                  <v-icon>mdi-close-circle-outline</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text style="padding-bottom: 30px;">
                <v-container>
                  <v-form ref="form" @submit.prevent="makeReturn">
                    <v-row class="d-flex justify-space-between mt-5">
                      <div style="width: 35%; display: flex; align-items: center; justify-content: end">
                        <span class="payment-text">Чек на</span>
                      </div>
                      <div style="width: 65%">
                        <v-btn-toggle
                            v-model="check_to"
                            mandatory
                            background-color="white"
                            class="mx-4 rounded-lg"
                        >
                          <v-btn>
                            <v-icon
                                small
                                dark
                                class="mr-2"
                            >
                              mdi-phone-incoming-outline
                            </v-icon>
                            Телефон
                          </v-btn>
                          <v-btn>
                            <v-icon
                                small
                                dark
                                class="mr-2"
                            >
                              mdi-email-outline
                            </v-icon>
                            Эл. почту
                          </v-btn>
                        </v-btn-toggle>
                      </div>
                    </v-row>
                    <v-btn-toggle
                        v-model="dialogTypeOfReturn"
                        mandatory
                        background-color="#FFFFFF"
                        class="rounded-lg"
                        style="margin-top: 40px; width: 100%"
                    >
                      <v-btn disabled style="background-color: #FFF !important;" width="50%">
                        Наличные
                      </v-btn>
                      <v-btn disabled style="background-color: #FFF !important;" width="50%">
                        Карта
                      </v-btn>
                    </v-btn-toggle>
                    <v-row class="mt-5">
                      <v-col cols="12">
                        <label>Касса</label>
                        <v-select
                            v-model="cashbox"
                            :rules="cashboxRules"
                            :items="listCashbox"
                            item-text="legal_entity"
                            item-value="serial"
                            class="rounded-lg"
                            :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                            label="Выбрать"
                            append-icon="mdi-chevron-down"
                            outlined
                            dense
                            required
                            color="#629F33"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row class="mt-5">
                      <v-col>
                        <label>Внесено</label>
                        <v-text-field
                            v-model="cash_in"
                            type="number"
                            outlined
                            disabled
                            dense
                            class="rounded-lg"
                            background-color="#F1F1F1"
                            color="success"
                        >
                          <template v-slot:append>
                            <span style="padding-top: 4px">₽</span>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col>
                        <label>К возврату</label>
                        <v-text-field
                            v-model="summ"
                            placeholder="0"
                            type="number"
                            hide-spin-buttons
                            :rules="summRules"
                            outlined
                            dense
                            class="rounded-lg"
                            color="#629F33"
                        >
                          <template v-slot:append>
                            <span style="padding-top: 4px">₽</span>
                          </template>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-btn
                            v-if="!isLoading2"
                            class="button button__success"
                            type="submit"
                            style="width: 100% !important; height: 48px !important;"
                            :disabled="isLoading || doingReturn"
                        >
                          Вернуть оплату
                        </v-btn>
                        <v-btn
                            class="button button__danger"
                            @click="cancelReceipt"
                            style="width: 100% !important; height: 48px !important; border-radius: 12px !important;"
                            :disabled="!doingReturn"
                        >
                          Отмена операции
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';
import {VueDatePicker} from "@mathieustan/vue-datepicker";
import {returnActionTypes} from '@/store/modules/return';
import {cashboxActionTypes} from '@/store/modules/cashbox';
import {billActionTypes} from '@/store/modules/bill';
import {getItem, setItem} from "../helpers/persistanceStorage";
import {mapState} from "vuex";

export default {
  name: "ReturnServiceDetail",
  props: ['client','buy', 'date'],
  components: {
    Header,
    Menu,
    VueDatePicker
  },
  data() {
    return {
      isLoading2:false,
      selectReturn: [],
      dialogModal: false,
      check_to: 0,
      dialogTypeOfReturn: 0,
      cashbox: null,
      cashboxRules: [
        v => !!v || 'Нужно выбрать кассу'
      ],
      main_bill: '',
      mainBillRules: [
        v => !!v || 'Лицевой счет обязательное поле'
      ],
      summ: null,
      cash_in: 0,
      transaction_sum: 0,
      summRules: [
        v => !!v || 'Введите сумму к возврату',
        v => parseInt(v) !== 0 || 'Введите сумму к возврату',
        v => v <= this.cash_in|| 'Сумма не должна быть больше внесенной суммы'
      ],
      return_id: null,
      headersReturn: [
        {text: 'Номенклатура, партия', align: 'start', sortable: false, value: 'service_name', width: '50%'},
        {text: 'Количество', align: 'start', value: 'count', width: '25%'},
        {text: 'Сумма', align: 'start', value: 'sum', width: '25%'},
      ],
      listCashbox: JSON.parse(getItem('list-cashbox')) ?? null,
      cashboxTerminal:"f0eb54ae-0b16-11ec-a060-60e32700ce56"
    }
  },
  methods: {
    setCashboxTerminal(){
      if(!this.listCashbox || !this.listCashbox[0]){
        alert('Не подключена или неполадки с кассой! Автоматически подставлена касса ИП Сорокин на Reception3_kl!')
      } 
      this.$store.dispatch(cashboxActionTypes.getCashboxDetail, {
        till_id: (this.listCashbox && this.listCashbox[0] && this.listCashbox[0].serial) ? this.listCashbox[0].serial : "00108723658089"
      }).then((resp) => {
       console.log(resp)
       if(resp && resp.cashbox && resp.cashbox.terminals && resp.cashbox.terminals.length > 0) {
          this.cashboxTerminal = resp.cashbox.terminals[0].id
       }
      //   else {
      //    alert('Неполадки с кассой, либо нет терминалов по выбранной кассе! Автоматически подставился стандартный теримнал ООО Клевер!')
      //  }
      })
    },
    modalReturn() {
      this.dialogModal = true;
      this.cash_in = this.selectReturn.reduce((res, i) => res + i.sum, 0)
      this.$store.dispatch(billActionTypes.getListBill,{
        client_id: this.client.client_id
      }).then(() => {
        this.cashbox = this.listCashbox ? this.listCashbox[0].serial : null;
      })
    },
    makeReturn() {
      if (this.$refs.form.validate()) {
        let list = [];
        for (let item of this.selectReturn) {
          list.push({
            service_id: item.service_id,
            service_name: item.service_name,
            count: item.count,
            sum: item.sum,
          })
        }
        this.isLoading2 = true;
        this.$store.dispatch(returnActionTypes.createReturn, {
          client_id: this.client.client_id,
          buy_id: this.buy.buy_id,
          return_list: list
        })
            .then((response) => {
              this.return_id = response.return.return_id;
              if (response.success) {
                this.$store.dispatch(returnActionTypes.returnReceipt, {
                  till_id: this.cashbox,
                  auth_code: this.transaction_sum >= this.buy.pay_sum ? this.buy.pay_list[0].transaction_id : null,
                  type: this.transaction_sum >= this.buy.pay_sum ? 3 : 1,
                  return_list: list
                })
                    .then((response) => {
                      this.isLoading2 = false;
                      if (response.success) {
                        this.$store.dispatch(returnActionTypes.makeReturn, {
                          client_id: this.client.client_id,
                          return_id: this.return_id,
                          till_id: this.cashbox,
                          type: this.transaction_sum >= this.buy.pay_sum ? 3 : 1,
                          summ: this.summ,
                          check_number: response.receipt_number,
                          bill_id: null,
                          terminal_id: this.transaction_sum >= this.buy.pay_sum ? this.cashboxTerminal : null,
                          transaction_id: this.transaction_sum >= this.buy.pay_sum ? response.auth_code : null,
                          transaction_date: this.transaction_sum >= this.buy.pay_sum ? new Date() : null
                        })
                            .then(() => {
                              this.$router.push({
                                name: 'Desktop',
                                params: {
                                  client_id: this.client.client_id
                                }
                              });
                            })
                      } else {
                        alert('Ошибка возврата!');
                      }
                    })
              }
            })
      }
    },
    cancelReceipt() {
      this.$store.dispatch(cashboxActionTypes.cancelReceipt, {
        till_id: this.cashbox
      })
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.cashbox.isLoading,
      doingReturn: state => state.refund.doingReturn,
      listBill: state => state.bill.list,
      validationErrors: state => state.cashbox.validationErrors,
    }),
  },
  mounted() {
    this.client !== undefined ? setItem('return-client',JSON.stringify(this.client)) : this.client = this.client = JSON.parse(getItem('return-client'));
    this.buy !== undefined ? setItem('return-buy',this.client) : this.client = getItem('return-buy');
    this.transaction_sum = this.buy.pay_list && this.buy.pay_list.length === 1 ? this.buy.pay_list[0].transaction_sum : 0;
    this.dialogTypeOfReturn = this.transaction_sum >= this.buy.pay_sum ? 1 : 0;
    this.setCashboxTerminal()
  },
  watch: {
    date() {
      this.$store.dispatch(returnActionTypes.getReturnProducts, {
        client_id: this.client.client_id,
        date: this.date
      })
    }
  }
}
</script>

<style scoped>
.custom__button {
  width: 180px;
  height: 30px;
  display: flex;
  padding: 7px;
  max-width: 180px;
  position: relative;
  box-sizing: content-box;
  align-items: center;
  flex-shrink: 0;
  margin-right: 0;
  border-radius: 12px;
  margin-bottom: 0;
  justify-content: center;
  background-color: var(--dl-color-default-primarysuccess);
  font-size: 16px;
  line-height: 24px;
  color: #fff !important;
}

.column {
  display: flex;
  justify-content: center;
  width: 100%;
}

.card-title {
  text-align: center;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: #000000;
  padding: 0 25px;
}

.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 48px!important;
  color: #767676!important;
  padding: 12px 20px;
  text-transform: none;
  font-family: 'Circe';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
}

.v-btn-toggle > .v-btn.v-btn--active > .v-btn__content > .v-icon {
  color: #629F33;
}

.theme--light.v-btn.v-btn--has-bg {
  background-color: #ffffff;
}
</style>